import { render, staticRenderFns } from "./vtl-menu.vue?vue&type=template&id=5f60061f"
import script from "./vtl-menu.vue?vue&type=script&lang=js"
export * from "./vtl-menu.vue?vue&type=script&lang=js"
import style0 from "./vtl-menu.vue?vue&type=style&index=0&id=5f60061f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports